import PropTypes from 'prop-types'
import {ProgressIndicator as PeacockProgressIndicator} from '@pepsico-ds/ui'

/**
 * ProgressIndicator component renders a ProgressIndicator with specified properties.
 *
 * @param {Object} props - The properties object.
 * @param {number} props.currentStep - The current step to render; default is 1.
 * @param {boolean} props.isDark - Render in dark mode if true.
 * @param {boolean} props.completed - Show the current step as completed if true.
 * @param {number} props.steps - The number of steps to render; default is 2.
 * @param {string[]} props.titles - Step titles; array length should match steps count.
 * @param {string} props.className - Additional class names for styling.
 * @param {string} [props.id=''] - Optional additional id to apply to the progress indicator.
 * @returns {JSX.Element} The rendered ProgressIndicator component.
 */

const ProgressIndicator = ({currentStep, isDark = false, completed, steps, titles, className, id}) => {
  return (
    <PeacockProgressIndicator
      data-testid={`progress_indicator` + (id ? `_${id}` : '')}
      id={`progress_indicator` + (id ? `_${id}` : '')}
      currentStep={currentStep}
      isDark={isDark}
      completed={completed}
      steps={steps}
      titles={titles}
      className={className}
    />
  )
}

ProgressIndicator.propTypes = {
  currentStep: PropTypes.number,
  isDark: PropTypes.bool,
  completed: PropTypes.bool,
  steps: PropTypes.number,
  titles: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  id: PropTypes.string,
}

export default ProgressIndicator
